import JOB from "./details/job.en";
import SALARY from "./details/salary.en";
import FAMILY from "./details/family.en";
import EDUCATION from "./details/education.en";

export default {
  ...JOB,
  ...SALARY,
  ...FAMILY,
  ...EDUCATION,
  
  EMPLOYEESGENERAL: {
    MESSAGE: {
      FIRSTNAME: "Nama",
      LASTNAME: "Nama Keluarga",
      EMAIL: "Emel",
      UNIQUE: "Kod Unik",
      EMPLOYEMENT: "Tarikh Mula Bekerja",
    },
  },

  EMPLOYEESCONTACT: {
    MESSAGE: {
      CONTACT: "Nombor Telefon Kecemasan",
      EMERGENCY: "Nama Kenalan",
      RELATIONSHIP: "Hubungan Dengan Pekerja",
      ADDRESS1: "Alamat 1",
      ADDRESS2: "Alamat 2",
      ADDRESS3: "Alamat 3",
      LOCALITY: "Kerakyatan",
      CITY: "Bandar",
      POSTALCODE: "Poskod",
      STATE: "Negeri",
    },
  },

  EMPLOYEESPERSONAL: {
    MESSAGE: {
      DOB: "Tarikh Lahir",
      GENDER: "Jantina",
      MARITALID: "Status Perkahwinan",
      ADDRESS1: "Alamat 1",
      ADDRESS2: "Alamat 2",
      ADDRESS3: "Alamat 3",
      LOCALITY: "Kerakyatan",
      CITY: "Bandar",
      POSTALCODE: "Poskod",
      STATE: "Negeri",
      PHONENUM: "Nombor Tel",
      IDENTITYTYPE: "Jenis Identiti",
      IDENTITYNUM: "Nombor Identiti",
    },
  },
};
